import React, {useEffect} from "react";

import {getVSIFileIcon} from "file-extension-icon-js";

import {Badge, Rate, Menu, Dropdown, List, message, Checkbox, Card} from "antd";

import services from "../../services";

import {
  validarVisualizar,
  validarSePassouDaDataDeValidade,
  validarData,
  getLastFolder,
  getIconesExtensao,
} from "../../services/utils";

import TableHeader from "../Table/Header";
import TablePagination from "../Table/Pagination";
import RowDragInDrop from "../Table/RowDragInDrop";

import IconeArquivos from "../IconeArquivos";

import menuAbrir from "../../assets/iconsMenu/menuAbrir.svg";
import menuInfo from "../../assets/iconsMenu/menuInfo.svg";
import favoritoSvg from "../../assets/icons/iconFavoritado.svg";
import menuFavorito from "../../assets/iconsMenu/menuFavorito.svg";
import iconDownloadSvg from "../../assets/icons/iconDownload.svg";
import iconLinkSvg from "../../assets/icons/iconLink.svg";
import menuEditar from "../../assets/iconsMenu/menuEditar.svg";
import menuRenomear from "../../assets/iconsMenu/menuRenomear.svg";
import menuMover from "../../assets/iconsMenu/menuMover.svg";
import menuCopiar from "../../assets/iconsMenu/menuCopiar.svg";
import menuRemover from "../../assets/iconsMenu/menuRemover.svg";


import pastaSvg from "../../assets/icons/infoPasta.svg";
import menuCompartilhar from "../../assets/iconsMenu/menuCompartilhar.svg";
import menuRemoverLink from "../../assets/icons/iconRemoverLink.svg";

import menuEditarCard from "../../assets/iconsMenu/menuEditarCard.svg";
import iconDownloadSvgCard from "../../assets/icons/iconDownloadCard.svg";
import word from "../../assets/icons/word.svg";
import excel from "../../assets/icons/excel.svg";
import power from "../../assets/icons/power.svg";
import txt from "../../assets/icons/txt.svg";
import pdf from "../../assets/icons/pdf.svg";
import mp4 from "../../assets/icons/mp4.svg";
import tiff from "../../assets/icons/tiff.svg";
import sem from "../../assets/icons/sem.svg";
import IcTresPontos from "../../assets/icons/iconeTresPontinhos.svg";
import "./styles.scss";
import moment from "moment";

const CardGaleria = ({
  data,
  mudarPagina,
  aumentarItensPorPagina,
  buscarPastasFilhas,
  showInfo,
  favoritar,
  showEditar,
  showRenomear,
  removerItem,
  IsAdmin,
  downloadFile,
  gerarLinkunico,
  handleRemoverFavorito,
  mostrarListagemLinks,
  handleRemoverLink,
  showModalVisualizar,
  atualizarPastasDragInDrop,
  showModalCompartilhar,
  showModalCopiar,
  showModalMover,
  mostrarListagemFavoritos,
  handleAlterarClassificacao,
  selecionarItemParaDownload,
  marcarTodosItens,
  isSelectAll,
  treeData,
  setItensSelecionados,
  itemsSelecionadosMover
}) => {
  const tabelaColunas = [
    <img src={favoritoSvg} />,
    <Checkbox
      checked={isSelectAll}
      onClick={(event) => marcarTodosItens(event.target.checked, data?.lista)}
      type="checkbox">
      Selecionar
    </Checkbox>,
    "Nome",
    "Autor",
    "Tamanho",
    "Tipo",
    "Data de inclusão",
    "Data validade",
  ]; 

  const formatarData = (value) => {
    if (value) {
      const data = new Date(value);
      return data.toLocaleDateString("pt-BR", {timeZone: "UTC"});
    }
  };

  const visualizacao = (item) => {
    let extensaoValida = validarVisualizar(item.extensao);

    if (
      extensaoValida != "nao-suportado" &&
      !validarSePassouDaDataDeValidade(item.dataVencimento)
    ) {
      return (
        <>
          <Menu.Item
            key="1"
            onClick={() => showModalVisualizar(item)}
            icon={<img src={menuAbrir} />}>
            Visualizar
          </Menu.Item>
          <hr className="linha-menu" />
        </>
      );
    }
  };
  const showMenu = (id, tipo, item) => {
    return (
      <div className="menu">
        <Menu>
          {tipo == "pasta" && !validarSePassouDaDataDeValidade(item.dataVencimento) ? (
            <>
              <Menu.Item
                key="1"
                onClick={() => buscarPastasFilhas(id, tipo, item.nome)}
                icon={<img src={menuAbrir} />}>
                Abrir
              </Menu.Item>
              <hr className="linha-menu" />
            </>
          ) : (
            <>{visualizacao(item)}</>
          )}
          <Menu.Item key="2" onClick={() => showInfo(id, tipo)} icon={<img src={menuInfo} />}>
            Info
          </Menu.Item>
          {item.ehFavorito ? (
            <Menu.Item
              key="3"
              onClick={() => handleRemoverFavorito(item)}
              icon={<img src={menuFavorito} />}>
              Remover favorito
            </Menu.Item>
          ) : (
            <Menu.Item key="3" onClick={() => favoritar(item)} icon={<img src={menuFavorito} />}>
              Favorito
            </Menu.Item>
          )}
          <hr className="linha-menu" />
          {!validarSePassouDaDataDeValidade(item.dataVencimento) ? (
            <Menu.Item
              key="4"
              onClick={() => downloadFile(item)}
              icon={<img src={iconDownloadSvg} />}>
              Fazer download...
            </Menu.Item>
          ) : null}
          {mostrarListagemLinks && (
            <Menu.Item
              key="5"
              onClick={() => {
                gerarLinkunico(item);
              }}
              icon={<img src={iconLinkSvg} />}>
              Gerenciar link
            </Menu.Item>
          )}
          {mostrarListagemLinks == false && !validarData(item.dataVencimento) && (
            <Menu.Item
              key="5"
              onClick={() => {
                gerarLinkunico(item);
              }}
              icon={<img src={iconLinkSvg} />}>
              Obter link
            </Menu.Item>
          )}
          {mostrarListagemLinks && (
            <Menu.Item
              key="6"
              onClick={() => {
                handleRemoverLink(item.id);
              }}
              icon={<img src={menuRemoverLink} />}>
              Remover link
            </Menu.Item>
          )}
          {item.tipo == 0 && !mostrarListagemFavoritos ? (
            <Menu.Item
              key="7"
              onClick={() => {
                showModalCompartilhar(item);
              }}
              icon={<img src={menuCompartilhar} />}>
              Compartilhar
            </Menu.Item>
          ) : null}
          {IsAdmin.toLocaleLowerCase() == "true" && (
            <>
              <hr className="linha-menu" />
              <Menu.Item
                key="8"
                onClick={() => showEditar(id, tipo)}
                icon={<img src={menuEditar} />}>
                Editar
              </Menu.Item>
              <Menu.Item
                key="9"
                onClick={() => showRenomear(id, tipo)}
                icon={<img src={menuRenomear} />}>
                Renomear
              </Menu.Item>
              <>
                <Menu.Item
                  key="10"
                  icon={<img src={menuMover} />}
                  onClick={() => showModalMover(item)}>
                  Mover
                </Menu.Item>
                <Menu.Item
                  key="11"
                  icon={<img src={menuCopiar} />}
                  onClick={() => showModalCopiar(item)}>
                  Copiar
                </Menu.Item>
              </>
              <hr className="linha-menu" />
              <Menu.Item
                key="12"
                onClick={() => removerItem(id, tipo)}
                icon={<img src={menuRemover} />}>
                Remover
              </Menu.Item>
            </>
          )}
        </Menu>
      </div>
    );
  };

  const handleEntrarVisualizar = (item) => {
    if (item.tipo == 0) {
      buscarPastasFilhas(item.id, "pasta", item.nome);
    }

    if (item.tipo == 1) {
      if (validarVisualizar(item.extensao) !== "nao-suportado") {
        showModalVisualizar(item);
      } else {
        message.warning("Extensão não tem suporte a visualização");
      }
    }
  };
  
  const preImagemArquivo = (item) => {
    if (item.urlPreview)
      return item.urlPreview;
    
      return getIconesExtensao(item.extensao);
  };
  
  const handleChangeClassificacao = (item, e) => {
    handleAlterarClassificacao(item, e);
  };

  return (
    <>
      <div
        className="main-container__section mt-3"
        onClick={(e) => e.stopPropagation()}
        style={{marginLeft: 10}}>
        <div className="main-container__column material-checkbox-group material-checkbox-group_primary">
          <input
            type="checkbox"
            className="material-checkbox"
            id="checkbox1"
            checked={isSelectAll}
            onClick={(event) => marcarTodosItens(event.target.checked, data?.lista)}
          />
          <label
            htmlFor="checkbox1"
            className="material-checkbox-group__label"
            style={{paddingLeft: 40}}>
            Selecionar todos
          </label>
        </div>
      </div>

      <div className="row todosCards">
        {(!data?.lista || data?.lista.length === 0) && (
          <div className="col-12 text-center"> Sem Registros </div>
        )}
        {data?.lista &&
          data?.lista?.map((item, index) => (
            <div
              key={index}
              className="cardArquivos"
              style={{border: item.checked ? "solid 3px #0042dd" : "solid 3px #EEEEEE"}}>
              <RowDragInDrop
                treeData={treeData}
                key={index}
                data={item}
                setItensSelecionados={setItensSelecionados}
                itensSelecionados={itemsSelecionadosMover}
                atualizarPastasDragInDrop={atualizarPastasDragInDrop}
                style={{
                  display: "block",
                  padding: "0"
                }}>
                <Card
                  hoverable
                  cover={
                    item?.tipo == 1 ? (
                      <div className="divImgCard">
                        <div className="imgCard" style={{backgroundImage: `url(${preImagemArquivo(item)})`}}></div>
                      </div>
                    ) : (
                      <div className="imgCardPasta">
                        <img
                          src={pastaSvg}
                          alt="pasta"
                          width={"50%"}
                          className={
                            validarSePassouDaDataDeValidade(item?.dataVencimento)
                              ? "pasta-arquivo-pos-validade w-100"
                              : ""
                          }
                        />
                      </div>
                    )
                  }
                  actions={[
                    <div
                      className="coracao"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        item.ehFavorito ? handleRemoverFavorito(item) : favoritar(item)
                      }}>
                      <input
                        type="checkbox"
                        checked={item?.ehFavorito}
                        id={"coracao" + index}
                        className="coracaoFavorito"
                      />
                      <label htmlFor={"coracao" + index}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="35"
                          height="35"
                          viewBox="0 0 24 24"
                          fill="#e7e7e7"
                          stroke="#e7e7e7">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke={item?.ehFavorito ? "#0042dd" : "#777777"}
                            strokeWidth="0.5"
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                          /> 
                        </svg>
                      </label>
                    </div>,
                    <div
                      className="main-container__section position-absolute"
                      onClick={(e) => e.stopPropagation()}>
                      <div className="main-container__column material-checkbox-group material-checkbox-group_primary">
                        <input
                          type="checkbox"
                          className="material-checkbox"
                          id={"checkbox1" + index}
                          checked={item?.checked}
                          onChange={(e) =>{ selecionarItemParaDownload(e.target.checked, item); }}
                        /> 
                        <label
                          htmlFor={"checkbox1" + index}
                          className="material-checkbox-group__label"
                        />
                      </div>
                    </div>,
                  ]}
                  onClick={() => handleEntrarVisualizar(item)}>
                  <div
                    className="divTresPontos"
                    onClick={(e) => e.stopPropagation()}
                    title={item?.nome}
                    style={{position: "relative", zIndex: 1, cursor: "default"}}>
                    <Card.Meta title={item?.nome} />
                    {item?.tipo != null && (
                      <div onClick={(e) => e.stopPropagation()} className=" tresPontos">
                        <Dropdown.Button
                          trigger={["click"]}
                          style={{backgroundColor: "transparent"}}
                          overlay={() =>
                            showMenu(item?.id, item?.tipo == 0 ? "pasta" : "arquivo", item)
                          }
                          icon={<img src={IcTresPontos} alt="Ícone" />}
                          placement="bottomLeft"></Dropdown.Button>
                      </div>
                    )}
                  </div>
                  <hr className="linha" />

                  {IsAdmin.toLocaleLowerCase() == "true" ? (
                    <div
                      className="d-flex align-items-center"
                      onClick={(e) => {
                        e.stopPropagation();
                        showEditar(item?.id, item?.tipo);
                      }}>
                      <img src={menuEditarCard} alt="editar" className="my-2 mr-2" />
                      <span>Editar</span>
                    </div>
                  ) : (
                    <div style={{minHeight: 32}}> </div>
                  )}

                  <div
                    className="d-flex align-items-center"
                    onClick={(e) => {
                      e.stopPropagation();
                      downloadFile(item);
                    }}>
                    <img src={iconDownloadSvgCard} alt="editar" className="my-2 mr-2" />
                    <span>Download</span>
                  </div>
                </Card>
              </RowDragInDrop>
            </div>
          ))}

      </div>
        <TablePagination
          data={data}
          changePage={mudarPagina}
          changeItensPerPage={aumentarItensPorPagina}
        />
    </>
  );
};

export default CardGaleria;
